module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8Fp8N6/tc-custom/9781398430440.jpg?1705541262302",
      "alt": "This image is the cover for the book Charlie the Cherry Picker"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Charlie the Cherry Picker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Modern life can present many challenges for young people as they strive to cope with growing up in a world which, as a result of peer pressure and unrealistic expectations, can sometimes just seem overwhelming. Charlie is such a child, and one who finds that the solution to these pressures may be found closer to home, and in an unexpected location. Charlie realises that she is not alone in experiencing these feelings and that help, and support is readily available. Charlie discovers where this support can be found and who can provide it in her role as a cherry picker.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Mairs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sarah lives in Hertfordshire with her husband and two grown up children."), _c('br'), _vm._v("She has had a varied career, including a short stint in the police force; a residential social worker, and for 18 years as a teaching assistant in a special needs school. Sarah also volunteered for her local hospice. She enjoys all things creative, and can often be found in her shed with various ideas buzzing around her head.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0